export default __webpack_public_path__ + "static/media/Ballroll_00240.4a81f00e.png";